import { Controller } from "@hotwired/stimulus"
import { BrowserMultiFormatReader } from "@zxing/library"

export default class extends Controller {
  static targets = ['scanbook', 'kubeId']

  initialize() {
    this.scanner = new BrowserMultiFormatReader()
    this.scanning = false
  }

  scanbookTargetConnected(element) {
    this.instantiate(element)
  }

  async instantiate(element) {
    // Create video element if it doesn't exist
    if (!element.querySelector('video')) {
      const video = document.createElement('video')
      video.style.width = '100%'
      video.style.height = '300px'
      video.autoplay = true
      video.playsInline = true
      element.appendChild(video)
    }

    const videoElement = element.querySelector('video')

    try {
      // Get available video input devices
      const videoInputDevices = await this.scanner.listVideoInputDevices()
      
      // Prefer back camera (environment)
      const backCamera = videoInputDevices.find(device => 
        device.label.toLowerCase().includes('back') || 
        device.label.toLowerCase().includes('rear') ||
        device.label.toLowerCase().includes('environment')
      )
      const selectedDeviceId = (backCamera && backCamera.deviceId) || 
                               (videoInputDevices[0] && videoInputDevices[0].deviceId)

      // Start scanning
      this.startScanning(videoElement, selectedDeviceId)
      
    } catch (err) {
      console.error('Erreur lors de l\'initialisation du scanner:', err)
      this.showError('Erreur d\'accès à la caméra. Vérifiez les permissions.')
    }
  }

  startScanning(videoElement, deviceId) {
    if (this.scanning) return

    this.scanning = true
    this.scanner.decodeFromVideoDevice(deviceId, videoElement, (result, error) => {
      if (result) {
        this.onScanSuccess(result.getText())
        this.stopScanner()
      }
      if (error && !(error.name === 'NotFoundException')) {
        console.error('Erreur du scanner:', error)
      }
    })
  }

  onScanSuccess(decodedText) {
    console.log('Code scanned:', decodedText)

    let form = document.getElementById("frm_scanner")
    if (form) {
      form.elements['term'].value = decodedText
      form.requestSubmit()
    }

    // Stop scanner after successful scan
    this.stopScanner()
  }

  scan(event) {
    console.log('Scanner method called')
    // Method called by "Scanner un livre!" button
    if (this.hasKubeIdTarget) {
      const modal = document.querySelector('turbo-frame#modal')
      if (modal) {
        modal.src = `/scan-books?kube_id=${this.kubeIdTarget.value}`
      }
    }
    event.preventDefault()
  }


  bookSelected(e) {
    window.dispatchEvent(
      new CustomEvent(
        "books:selected",
        {
          detail: {
            content: e.target.dataset.info
          }
        }
      )
    )
  }

  stopScanner() {
    if (this.scanner && this.scanning) {
      this.scanner.reset()
      this.scanning = false
    }
  }

  showError(message) {
    if (this.hasScanbookTarget) {
      const errorDiv = document.createElement('div')
      errorDiv.className = 'alert alert-danger'
      errorDiv.textContent = message
      this.scanbookTarget.appendChild(errorDiv)
    }
  }

  disconnect() {
    this.stopScanner()
    if (this.scanner) {
      this.scanner.reset()
      this.scanner = null
    }
  }
}
